import type { TideResponse } from '@tideprecision/shared';

interface Props {
  data: TideResponse;
}

const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

function formatJstTime(iso: string): string {
  const t = new Date(iso);
  const jst = new Date(t.getTime() + JST_OFFSET_MS);
  const hh = String(jst.getUTCHours()).padStart(2, '0');
  const mm = String(jst.getUTCMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

export function ExtremaList({ data }: Props): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {data.extrema.map((e, i) => {
        const isHigh = e.kind === 'high';
        return (
          <div
            key={i}
            className={`rounded p-3 ${isHigh ? 'bg-rose-900/40 border border-rose-700/40' : 'bg-cyan-900/40 border border-cyan-700/40'}`}
          >
            <div className={`text-xs font-bold ${isHigh ? 'text-rose-300' : 'text-cyan-300'}`}>
              {isHigh ? '満潮' : '干潮'}
            </div>
            <div className="text-lg font-mono">{formatJstTime(e.time)}</div>
            <div className="text-sm text-slate-300">{e.level.toFixed(2)} m</div>
          </div>
        );
      })}
    </div>
  );
}
